import {createSelector} from 'reselect';
import getPaymentOptionsPermittedByDeliveryOption from './getPaymentOptionsPermittedByDeliveryOption';

const makeIsPaymentOptionDisabledByDeliveryOption = paymentType => createSelector(
  [getPaymentOptionsPermittedByDeliveryOption],
  permittedPaymentOptions => permittedPaymentOptions.length > 0
    && !permittedPaymentOptions.includes(paymentType),
);

export default makeIsPaymentOptionDisabledByDeliveryOption;
